import { css } from 'lit';

export const style = css`:host section{display:flex;flex-direction:column}:host section .results{padding-top:20px;padding-bottom:10px;border-bottom:2px solid var(--zui-gray-100);color:var(--zui-gray)}:host section .item-container{border-bottom:2px solid var(--zui-gray-100)}`;
